module.exports = "/assets/landing-cf/team-placeholder@2x.jpg?MaOpe1t";